import { SVGProps } from 'react';

const ArrowDownToLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 17V3m6 8-6 6-6-6m13 10H5"
    />
  </svg>
);
export default ArrowDownToLine;
